// WhatsApp share helpers — wa.me/?text= scheme (native app on mobile, Web on desktop).
// Note: encodeURIComponent encodes "*" as %2A, which WhatsApp decodes back to "*" and
// renders as bold — so bold markdown is preserved. Functionality first regardless.

const FOOTER = "\n\nShared via 3 Realty";

export function waUrl(text) {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

// Synchronous open (safe inside a click handler with no awaits before it).
export function openWhatsApp(text) {
  window.open(waUrl(text), "_blank", "noopener");
}

// For async flows: open a blank tab synchronously (within the gesture), then
// navigate it once the link is ready — avoids popup blockers after await.
export function openWhatsAppWindow(win, text) {
  const url = waUrl(text);
  if (win) win.location.href = url;
  else window.open(url, "_blank", "noopener");
}

function clean(v) {
  return v && v !== "—" ? String(v).trim() : "";
}

function loc(a) {
  return [clean(a.city_label), clean(a.village_label)].filter(Boolean).join(", ") || "—";
}

export function mapsUrl(a) {
  const q = clean(a.asset_address) || [clean(a.village_label), clean(a.city_label)].filter(Boolean).join(" ");
  return `https://maps.google.com/?q=${encodeURIComponent(q || a.name || "")}`;
}

export function locationMessage(a) {
  return `📍 Asset Location — ${a.name} (${a.asset_code})\n${loc(a)}\n\nGoogle Maps: ${mapsUrl(a)}${FOOTER}`;
}

export function summaryMessage(a) {
  const price = a.offer_price_inr ? `₹${Number(a.offer_price_inr).toLocaleString("en-IN")}` : "—";
  const area = a.area_sqft ? `${Number(a.area_sqft).toLocaleString("en-IN")} sq.ft` : "—";
  const cat = [clean(a.category_label), clean(a.type_label)].filter(Boolean).join(" — ") || "—";
  return [
    `🏢 *${a.name}*`,
    `*Code:* ${a.asset_code}`,
    `*Category:* ${cat}`,
    `*Location:* ${loc(a)}`,
    `*Offer Price:* ${price}`,
    `*Sale Type:* ${clean(a.sale_type_label) || "—"}`,
    `*Area:* ${area}`,
    "",
    "For details and documents, contact 3 Realty.",
  ].join("\n");
}

export function fileMessage(a, fileName, url, isMedia) {
  const head = isMedia ? `🖼️ ${a.name} — Property Media` : `📄 Document — ${fileName}`;
  const line2 = isMedia ? "" : `\nAsset: ${a.name} (${a.asset_code})`;
  return `${head}${line2}\nLocation: ${loc(a)}\n\n${url}${FOOTER}`;
}

export function multiFileMessage(a, items) {
  const lines = items.map((it, i) => `${i + 1}. ${it.file_name}: ${it.url}`).join("\n");
  return `📁 Files — ${a.name} (${a.asset_code})\nLocation: ${loc(a)}\n\n${lines}${FOOTER}`;
}

export function folderMessage(a, folderName, url, fileCount) {
  const files = fileCount != null ? `\nFiles: ${fileCount} document${fileCount === 1 ? "" : "s"}` : "";
  return `📁 *${folderName}*\nAsset: ${a.name} (${a.asset_code})\nLocation: ${loc(a)}${files}\n\nView all files:\n${url}${FOOTER}`;
}
